/* NMR YOUTUBE VIDEO R110 — WARM START / LOCKED PLAYER */
(() => {
  'use strict';

  const ROOT = '[data-nmr-youtube-video]';

  function post(iframe,payload) {
    if (!iframe?.contentWindow) return;

    iframe.contentWindow.postMessage(
      JSON.stringify(payload),
      '*'
    );
  }

  function handshake(iframe) {
    post(iframe,{
      event:'listening',
      id:iframe.id || undefined
    });
  }

  function command(iframe,func,args=[]) {
    post(iframe,{
      event:'command',
      func,
      args
    });
  }

  function enforce(iframe,reset=false) {
    handshake(iframe);
    command(iframe,'mute');
    command(iframe,'setVolume',[0]);

    if (reset) {
      command(iframe,'seekTo',[0,true]);
    }

    command(iframe,'playVideo');
  }

  function reveal(section) {
    section.dataset.nmrYoutubeRevealed = 'true';
  }

  function start(section) {
    if (
      !section ||
      section.dataset.nmrYoutubeStarted === 'true'
    ) {
      return;
    }

    section.dataset.nmrYoutubeStarted = 'true';

    const iframe =
      section.querySelector('[data-nmr-youtube-player]');

    if (!iframe) {
      reveal(section);
      return;
    }

    const startedAt = performance.now();
    let attempts = 0;

    enforce(iframe,true);

    window.setTimeout(
      () => reveal(section),
      80
    );

    const timer =
      window.setInterval(
        () => {
          attempts += 1;

          enforce(
            iframe,
            attempts <= 2
          );

          if (
            performance.now() - startedAt >= 2200 ||
            attempts >= 12
          ) {
            clearInterval(timer);
          }
        },
        180
      );
  }

  function startAll() {
    document
      .querySelectorAll(ROOT)
      .forEach(start);
  }

  function onPageComplete() {
    window.setTimeout(startAll,20);
  }

  if (document.readyState === 'complete') {
    onPageComplete();
  } else {
    window.addEventListener(
      'load',
      onPageComplete,
      {once:true}
    );
  }

  document.addEventListener(
    'visibilitychange',
    () => {
      if (document.hidden) return;

      document
        .querySelectorAll(ROOT)
        .forEach((section) => {
          const iframe =
            section.querySelector(
              '[data-nmr-youtube-player]'
            );

          if (iframe) {
            enforce(iframe,false);
          }
        });
    }
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section =
        event.target.matches?.(ROOT)
          ? event.target
          : event.target.querySelector?.(ROOT);

      if (!section) return;

      section.dataset.nmrYoutubeStarted = 'false';
      section.dataset.nmrYoutubeRevealed = 'false';

      window.setTimeout(
        () => start(section),
        20
      );
    }
  );
})();
